// src/lib/transactionI18n.ts
import { useTranslation } from 'react-i18next';

type Dict = Record<string, string>;

const fr: Dict = {
  // Commun transactionnel
  active: 'Actif',
  redeemed: 'Utilisé',
  expired: 'Expiré',
  cancelled: 'Annulé',
  canceled: 'Annulé',
  pending: 'En attente',
  paid: 'Payé',
  succeeded: 'Réussi',
  completed: 'Complété',
  processing: 'En traitement',
  failed: 'Échoué',
  refunded: 'Remboursé',
  unknown: 'Inconnu',
  order: 'Commande',
  orders: 'Commandes',
  voucher: 'Voucher',
  vouchers: 'Vouchers',
  customer: 'Client',
  amount: 'Montant',
  status: 'Statut',
  payment: 'Paiement',
  actions: 'Actions',
  details: 'Détails',
  refresh: 'Actualiser',
  print: 'Imprimer',
  support: 'Support',
  close: 'Fermer',
  retry: 'Réessayer',
  loading: 'Chargement',
  account: 'Compte',
  date: 'Date',
  total: 'Total',
  taxes: 'Taxes',
  subtotal: 'Sous-total',
  quantity: 'Quantité',
  createdOn: 'Créée le',
  expiresOn: 'Expiration',
  usedOn: 'Utilisé le',
  validatedBy: 'Validé par',
  noDateDefined: 'Aucune date définie',
  partnerBusiness: 'Commerce partenaire',
  manualEntry: 'Saisie manuelle',
  merchantCamera: 'Caméra marchand',

  // Mes achats
  purchasesBadge: 'Achats',
  purchasesTitle: 'Mes achats',
  purchasesSubtitle: 'Retrouvez vos commandes, taxes, reçus et forfaits Forfeo au même endroit.',
  explore: 'Explorer',
  paidOrders: 'Payées',
  loadingPurchases: 'Chargement des achats...',
  noPurchasesTitle: 'Aucun achat pour l’instant',
  noPurchasesSubtitle: 'Vos commandes Forfeo apparaîtront ici après paiement.',
  exploreShop: 'Explorer la boutique',
  purchasesLoadError: 'Impossible de charger vos achats pour le moment. Vérifiez votre connexion ou réessayez plus tard.',
  totalPaid: 'Total payé',
  items: 'Articles',
  futureItemDetails: 'Les détails des articles seront visibles ici pour les prochaines commandes enrichies.',
  futureTaxDetails: 'Les taxes détaillées seront affichées pour les commandes créées après la mise à jour.',
  voucherTickets: 'Vouchers / billets',
  noVoucherForOrder: 'Aucun voucher visible pour cette commande. Pour une commande payée récente, renvoyez l’événement Stripe ou relancez le webhook.',
  session: 'Session',
  pendingText: 'en attente',
  voucherForfeo: 'Voucher Forfeo',
  voucherCancelled: 'Ce voucher a été annulé.',
  expiredPrefix: 'Expiré',

  // Voucher detail
  backToPurchases: 'Retour à mes achats',
  loadingVoucher: 'Chargement du voucher...',
  voucherUnavailable: 'Voucher indisponible',
  voucherNotFound: 'Voucher introuvable ou non accessible.',
  voucherTechError: 'Erreur technique lors du chargement du voucher.',
  returnToPurchases: 'Revenir à mes achats',
  officialVoucher: 'Voucher Forfeo officiel',
  experienceForfeo: 'Expérience Forfeo',
  voucherActiveInstructions: 'Présentez ce QR code au partenaire au moment de votre visite.',
  voucherStatusUpdated: 'Le statut de ce voucher a été mis à jour dans le système Forfeo.',
  qrCannotBeUsed: 'Ce QR code ne peut plus être utilisé.',
  usagePeriodExpired: 'La période d’utilisation est expirée.',
  voucherWasCancelled: 'Ce voucher a été annulé.',
  voucherUsed: 'Voucher utilisé',
  voucherUsedMessage: 'Ce voucher a déjà été validé',
  validationRecordedBy: 'Validation enregistrée par',
  voucherExpired: 'Voucher expiré',
  voucherExpiredMessage: 'Ce voucher n’est plus utilisable. Communiquez avec le support Forfeo si vous pensez qu’il s’agit d’une erreur.',
  voucherCancelledTitle: 'Voucher annulé',
  voucherCancelledMessage: 'Ce voucher a été annulé et ne peut pas être présenté au partenaire.',
  summary: 'Résumé',
  value: 'Valeur',
  createdAt: 'Créé le',
  forfeoSecurity: 'Sécurité Forfeo',
  voucherSecurityActive: 'Ce voucher est protégé par un token unique. Ne partagez ce QR code qu’au partenaire au moment de l’utilisation.',
  voucherSecurityInactive: 'Ce statut provient du système sécurisé Forfeo. En cas de question, contactez le support avec le code du voucher.',
  printVoucher: 'Imprimer le voucher',
  downloadVoucherPdf: 'Télécharger le billet PDF',
  downloadReceiptPdf: 'Télécharger le reçu PDF',
  preparingPdf: 'Préparation du PDF...',
  pdfGenerationError: 'Impossible de générer le PDF pour le moment.',

  // Réservations
  reservationsBadge: 'Réservations',
  reservationsTitle: 'Mes réservations',
  reservationsSubtitle: 'Retrouvez vos réservations Last Call et expériences confirmées.',
  reservationsLoadError: 'Impossible de charger vos réservations pour le moment. Vérifiez votre connexion ou réessayez plus tard.',
  loadingReservations: 'Chargement des réservations...',
  noReservationsTitle: 'Aucune réservation pour l’instant',
  noReservationsSubtitle: 'Vos réservations Last Call apparaîtront ici après confirmation.',
  discoverLastCall: 'Découvrir Last Call',
  reservationForfeo: 'Réservation Forfeo',
  confirmed: 'confirmée',
  place: 'Lieu',
  schedule: 'Horaire',
  contact: 'Contact',
  gps: 'GPS',
  help: 'Aide',

  // Espace voyageur
  travelerSpace: 'Espace voyageur',
  hello: 'Bonjour',
  travelerDefault: 'voyageur',
  travelerSubtitle: 'Retrouvez vos alertes, réservations, achats et favoris dans un seul espace sécurisé.',
  connectedWith: 'Connecté avec',
  signOut: 'Déconnexion',
  loadingTraveler: 'Chargement de votre espace...',
  recentActivity: 'Activité récente',
  recentActivitySubtitle: 'Vos derniers mouvements sur Forfeo.',
  noRecentActivity: 'Aucune activité récente',
  noRecentActivitySubtitle: 'Commencez avec une alerte Évasion ou une offre Last Call.',
  createAlert: 'Créer une alerte',
  bookLastCall: 'Réserver une offre Last Call',
  bookLastCallSubtitle: 'Des prix verrouillés sur des expériences locales limitées.',
  exploreShopCard: 'Explorer la boutique',
  exploreShopCardSubtitle: 'Forfaits, cadeaux et expériences à offrir ou à vivre.',
  privateData: 'Données privées',
  privateDataSubtitle: 'Vos achats et réservations sont filtrés par votre compte ou votre adresse courriel.',
  evasionAlerts: 'Alertes Évasion',
  favorites: 'Favoris',
  travelerPartialError: 'Certaines données sont temporairement indisponibles, mais votre espace reste accessible.',
  travelerLoadError: 'Impossible de charger votre espace voyageur pour le moment.',
  departure: 'Départ',
  destination: 'Destination',
  budget: 'Budget',
  toWatch: 'à surveiller',
  saved: 'Sauvegardé',

  // Business scanner
  cameraRequiresHttps: 'La caméra exige une connexion HTTPS. Le site en production est compatible.',
  cameraPermissionDenied: 'Permission caméra refusée. Autorise la caméra dans le navigateur ou entre le code manuellement.',
  cameraStartError: 'Impossible de démarrer la caméra. Réessaie ou utilise le champ manuel.',
  quickScanner: 'Scanner Rapide',
  scannerPlaceholder: 'Ex: PICK-XXXX, FE-XXXX ou lien /voucher',
  openingCamera: 'Ouverture caméra...',
  closeCamera: 'Fermer la caméra',
  scanWithCamera: 'Scanner avec caméra',
  placeQrInFrame: 'Place le QR code du voucher dans le cadre',
  cameraCompatible: 'Compatible avec les liens /voucher et les codes FE-XXXX.',
  enterVoucherCode: 'Veuillez entrer un code de réservation ou un voucher Forfeo.',
  voucherActiveFor: 'Voucher actif pour',
  canMarkRedeemed: 'Vous pouvez maintenant le marquer comme utilisé.',
  voucherAlreadyUsed: 'Ce voucher a déjà été utilisé',
  voucherExpiredCannotUse: 'Ce voucher est expiré et ne peut plus être utilisé.',
  voucherCancelledCannotUse: 'Ce voucher est annulé et ne peut pas être utilisé.',
  voucherFoundStatus: 'Voucher trouvé, statut actuel',
  invalidCodeForBusiness: 'Code invalide ou introuvable pour votre établissement.',
  voucherNotAuthorized: 'Voucher introuvable ou non autorisé pour votre établissement.',
  invalidVoucher: 'Voucher non valide',
  cannotRedeemInactive: 'Ce voucher ne peut pas être marqué comme utilisé, car il n’est pas actif.',
  voucherRedeemedSuccess: 'Voucher marqué comme utilisé avec succès. La preuve est enregistrée dans le journal sécurisé Forfeo.',
  redeemError: 'Impossible d’utiliser ce voucher',
  recentRedemptions: 'Historique des validations récentes',
  redeemedForfeoVouchers: 'Vouchers Forfeo utilisés',
  noRecentRedeemedVouchers: 'Aucun voucher utilisé récemment.',
  markRedeemed: 'Marquer utilisé',
  confirming: 'Confirmation...',
  noActionForStatus: 'Aucune action disponible pour ce statut. Ce voucher ne peut pas être réutilisé.',
  validationAuditNote: 'Cette validation est maintenant inscrite dans le journal sécurisé Forfeo. Elle associe le voucher, le commerce et la source de validation.',
  voucherIsActiveConfirm: 'Le voucher est actif. Confirme seulement quand le client utilise réellement son achat.',


  // Business dashboard marchand
  businessDashboardTitleFallback: 'Mon Entreprise',
  businessDashboardSubtitle: 'Gérez vos activités, offres et réservations en un clin d’œil.',
  modify: 'Modifier',
  premiumPartner: 'Partenaire Premium',
  viewMyListing: 'Voir ma fiche',
  views: 'Vues',
  revenue: 'Revenus',
  validation: 'Validation',
  scan: 'Scan',
  scannerQrCode: 'Scanner Code QR',
  bookingTab: 'Réservations',
  shopOrdersTab: 'Commandes Shop',
  availabilityCalendar: 'Calendrier Dispos',
  hotelRestaurant: 'Hébergement & Resto',
  vipPresales: 'Préventes VIP',
  packageShop: 'Boutique Forfaits',
  flashOffers: 'Offres Flash',
  physicalProducts: 'Produits Physiques',
  stripeWallet: 'Portefeuille (Stripe)',
  messaging: 'Messagerie',
  newsPosts: 'Publications Actu',
  loyaltyClub: 'Club Fidélité',
  statistics: 'Statistiques',
  businessProfile: 'Profil Entreprise',
  accountManagement: 'Gestion du compte',
  helpCenterTutorials: 'Centre d’aide & Tutoriels',
  validPass: 'Bon valide',
  failure: 'Échec',
  warning: 'Attention',
  cameraNotAvailable: 'Caméra non disponible sur ce navigateur. Utilise le champ manuel.',
  cameraActive: 'Caméra active. Place le QR code dans le cadre.',
  checking: 'Vérification...',
  validateThisCode: 'Valider ce code',
  director: 'Directeur',
  employee: 'Employé',
  forfeoProofRecorded: 'Preuve Forfeo enregistrée',
  forfeoProofRecordedText: 'Cette validation est maintenant inscrite dans le journal sécurisé Forfeo. Elle associe le voucher, la commande, le commerce et l’utilisateur marchand connecté.',
  source: 'Source',
  merchantAction: 'Action marchand',
  redeemedNotReusable: 'Utilisé / non réutilisable',
  legacyOrderCodes: 'Anciens codes de commande',
  noHistoricalValidation: 'Aucune validation historique récente.',
  validated: 'Validé',
  orderHistory: 'Historique des commandes',
  noOrderRecorded: 'Aucune commande enregistrée pour le moment.',
  reference: 'Référence',
  anonymous: 'Anonyme',
  voucherCode: 'Code',
  businessNotFound: 'Entreprise introuvable.',

  // Admin vouchers
  adminPaymentsTitle: 'Centre paiements & vouchers',
  adminPaymentsSubtitle: 'Suivi des commandes, vouchers, validations marchand et anomalies webhook.',
  centerUnavailable: 'Centre admin indisponible',
  loadingAdminCenter: 'Chargement du centre paiements...',
  latestSync: 'Dernière synchronisation',
  paidOrdersStat: 'Commandes payées',
  pendingOrdersStat: 'Commandes en attente',
  activeVouchersStat: 'Vouchers actifs',
  redeemedVouchersStat: 'Vouchers utilisés',
  anomalies: 'Anomalies',
  recentViews: 'Vues récentes',
  checkBeforeSupport: 'À vérifier avant support',
  ordersVouchersLoaded: 'Commandes + vouchers chargés',
  searchPlaceholderAdmin: 'Rechercher par email, code voucher, ID commande, statut, Stripe...',
  actionCompleted: 'Action complétée',
  actionImpossible: 'Action impossible',
  anomaliesToCheck: 'Anomalies à vérifier',
  anomaliesSubtitle: 'Détection rapide des commandes/vouchers incohérents avec actions de secours sécurisées.',
  itemsCount: 'élément(s)',
  noAnomaly: 'Aucune anomalie détectée dans l’échantillon récent.',
  severity: 'Sévérité',
  type: 'Type',
  message: 'Message',
  regenerate: 'Régénérer',
  latestOrders: 'Dernières commandes',
  latestOrdersSubtitle: 'Commandes Shop/Stripe récentes avec statut de paiement.',
  noOrderFound: 'Aucune commande trouvée.',
  fulfillment: 'Fulfillment',
  receipt: 'Reçu',
  latestVouchers: 'Derniers vouchers',
  latestVouchersSubtitle: 'Vouchers générés récemment avec leur statut opérationnel.',
  noVoucherFound: 'Aucun voucher trouvé.',
  recentMerchantValidations: 'Dernières validations marchand',
  recentMerchantValidationsSubtitle: 'Journal des utilisations de vouchers par les partenaires.',
  noValidationFound: 'Aucune validation récente.',
  openOrderDetails: 'Détails commande',
  resendReceipt: 'Renvoyer reçu',
  regenerateVouchers: 'Régénérer vouchers',
  cancelVoucher: 'Annuler voucher',
};

const en: Dict = {
  active: 'Active', redeemed: 'Redeemed', expired: 'Expired', cancelled: 'Cancelled', canceled: 'Cancelled', pending: 'Pending', paid: 'Paid', succeeded: 'Succeeded', completed: 'Completed', processing: 'Processing', failed: 'Failed', refunded: 'Refunded', unknown: 'Unknown', order: 'Order', orders: 'Orders', voucher: 'Voucher', vouchers: 'Vouchers', customer: 'Customer', amount: 'Amount', status: 'Status', payment: 'Payment', actions: 'Actions', details: 'Details', refresh: 'Refresh', print: 'Print', support: 'Support', close: 'Close', retry: 'Retry', loading: 'Loading', account: 'Account', date: 'Date', total: 'Total', taxes: 'Taxes', subtotal: 'Subtotal', quantity: 'Quantity', createdOn: 'Created on', expiresOn: 'Expiration', usedOn: 'Redeemed on', validatedBy: 'Validated by', noDateDefined: 'No date defined', partnerBusiness: 'Partner business', manualEntry: 'Manual entry', merchantCamera: 'Merchant camera',
  purchasesBadge: 'Purchases', purchasesTitle: 'My purchases', purchasesSubtitle: 'Find your orders, taxes, receipts and Forfeo packages in one place.', explore: 'Explore', paidOrders: 'Paid', loadingPurchases: 'Loading purchases...', noPurchasesTitle: 'No purchases yet', noPurchasesSubtitle: 'Your Forfeo orders will appear here after payment.', exploreShop: 'Explore the shop', purchasesLoadError: 'Unable to load your purchases right now. Check your connection or try again later.', totalPaid: 'Total paid', items: 'Items', futureItemDetails: 'Item details will appear here for future enriched orders.', futureTaxDetails: 'Detailed taxes will be shown for orders created after the update.', voucherTickets: 'Vouchers / tickets', noVoucherForOrder: 'No voucher is visible for this order. For a recent paid order, resend the Stripe event or rerun the webhook.', session: 'Session', pendingText: 'pending', voucherForfeo: 'Forfeo voucher', voucherCancelled: 'This voucher has been cancelled.', expiredPrefix: 'Expired',
  backToPurchases: 'Back to my purchases', loadingVoucher: 'Loading voucher...', voucherUnavailable: 'Voucher unavailable', voucherNotFound: 'Voucher not found or not accessible.', voucherTechError: 'Technical error while loading the voucher.', returnToPurchases: 'Back to my purchases', officialVoucher: 'Official Forfeo voucher', experienceForfeo: 'Forfeo experience', voucherActiveInstructions: 'Show this QR code to the partner at the time of your visit.', voucherStatusUpdated: 'This voucher status has been updated in the Forfeo system.', qrCannotBeUsed: 'This QR code can no longer be used.', usagePeriodExpired: 'The redemption period has expired.', voucherWasCancelled: 'This voucher has been cancelled.', voucherUsed: 'Voucher redeemed', voucherUsedMessage: 'This voucher has already been validated', validationRecordedBy: 'Validation recorded by', voucherExpired: 'Voucher expired', voucherExpiredMessage: 'This voucher can no longer be used. Contact Forfeo support if you believe this is an error.', voucherCancelledTitle: 'Voucher cancelled', voucherCancelledMessage: 'This voucher has been cancelled and cannot be shown to the partner.', summary: 'Summary', value: 'Value', createdAt: 'Created on', forfeoSecurity: 'Forfeo security', voucherSecurityActive: 'This voucher is protected by a unique token. Only share this QR code with the partner when redeeming it.', voucherSecurityInactive: 'This status comes from the secure Forfeo system. If you have questions, contact support with the voucher code.', printVoucher: 'Print voucher', downloadVoucherPdf: 'Download PDF ticket', downloadReceiptPdf: 'Download PDF receipt', preparingPdf: 'Preparing PDF...', pdfGenerationError: 'Unable to generate the PDF right now.',
  reservationsBadge: 'Reservations', reservationsTitle: 'My reservations', reservationsSubtitle: 'Find your confirmed Last Call reservations and experiences.', reservationsLoadError: 'Unable to load your reservations right now. Check your connection or try again later.', loadingReservations: 'Loading reservations...', noReservationsTitle: 'No reservations yet', noReservationsSubtitle: 'Your Last Call reservations will appear here after confirmation.', discoverLastCall: 'Discover Last Call', reservationForfeo: 'Forfeo reservation', confirmed: 'confirmed', place: 'Location', schedule: 'Schedule', contact: 'Contact', gps: 'GPS', help: 'Help',
  travelerSpace: 'Traveler space', hello: 'Hello', travelerDefault: 'traveler', travelerSubtitle: 'Find your alerts, reservations, purchases and favorites in one secure space.', connectedWith: 'Signed in as', signOut: 'Sign out', loadingTraveler: 'Loading your space...', recentActivity: 'Recent activity', recentActivitySubtitle: 'Your latest Forfeo activity.', noRecentActivity: 'No recent activity', noRecentActivitySubtitle: 'Start with an Escape alert or a Last Call offer.', createAlert: 'Create an alert', bookLastCall: 'Book a Last Call offer', bookLastCallSubtitle: 'Locked-in prices on limited local experiences.', exploreShopCard: 'Explore the shop', exploreShopCardSubtitle: 'Packages, gifts and experiences to give or enjoy.', privateData: 'Private data', privateDataSubtitle: 'Your purchases and reservations are filtered by your account or email address.', evasionAlerts: 'Escape alerts', favorites: 'Favorites', travelerPartialError: 'Some data is temporarily unavailable, but your space remains accessible.', travelerLoadError: 'Unable to load your traveler space right now.', departure: 'Departure', destination: 'Destination', budget: 'Budget', toWatch: 'to watch', saved: 'Saved',
  cameraRequiresHttps: 'Camera access requires an HTTPS connection. The production site is compatible.', cameraPermissionDenied: 'Camera permission denied. Allow camera access in your browser or enter the code manually.', cameraStartError: 'Unable to start the camera. Try again or use manual entry.', quickScanner: 'Quick Scanner', scannerPlaceholder: 'Ex: PICK-XXXX, FE-XXXX or /voucher link', openingCamera: 'Opening camera...', closeCamera: 'Close camera', scanWithCamera: 'Scan with camera', placeQrInFrame: 'Place the voucher QR code inside the frame', cameraCompatible: 'Compatible with /voucher links and FE-XXXX codes.', enterVoucherCode: 'Please enter a reservation code or Forfeo voucher.', voucherActiveFor: 'Active voucher for', canMarkRedeemed: 'You can now mark it as redeemed.', voucherAlreadyUsed: 'This voucher has already been redeemed', voucherExpiredCannotUse: 'This voucher is expired and can no longer be used.', voucherCancelledCannotUse: 'This voucher is cancelled and cannot be used.', voucherFoundStatus: 'Voucher found, current status', invalidCodeForBusiness: 'Invalid code or not found for your business.', voucherNotAuthorized: 'Voucher not found or not authorized for your business.', invalidVoucher: 'Invalid voucher', cannotRedeemInactive: 'This voucher cannot be marked as redeemed because it is not active.', voucherRedeemedSuccess: 'Voucher marked as redeemed successfully. Proof is saved in the secure Forfeo log.', redeemError: 'Unable to redeem this voucher', recentRedemptions: 'Recent validation history', redeemedForfeoVouchers: 'Redeemed Forfeo vouchers', noRecentRedeemedVouchers: 'No recently redeemed voucher.', markRedeemed: 'Mark redeemed', confirming: 'Confirming...', noActionForStatus: 'No action is available for this status. This voucher cannot be reused.', validationAuditNote: 'This validation is now recorded in the secure Forfeo log. It links the voucher, the business and the validation source.', voucherIsActiveConfirm: 'The voucher is active. Confirm only when the customer is actually redeeming their purchase.',

  businessDashboardTitleFallback: 'My business',
  businessDashboardSubtitle: 'Manage your activities, offers and reservations at a glance.',
  modify: 'Edit',
  premiumPartner: 'Premium partner',
  viewMyListing: 'View my listing',
  views: 'Views',
  revenue: 'Revenue',
  validation: 'Validation',
  scan: 'Scan',
  scannerQrCode: 'QR code scanner',
  bookingTab: 'Reservations',
  shopOrdersTab: 'Shop orders',
  availabilityCalendar: 'Availability calendar',
  hotelRestaurant: 'Accommodation & dining',
  vipPresales: 'VIP presales',
  packageShop: 'Package shop',
  flashOffers: 'Flash offers',
  physicalProducts: 'Physical products',
  stripeWallet: 'Wallet (Stripe)',
  messaging: 'Messages',
  newsPosts: 'News posts',
  loyaltyClub: 'Loyalty club',
  statistics: 'Statistics',
  businessProfile: 'Business profile',
  accountManagement: 'Account management',
  helpCenterTutorials: 'Help center & tutorials',
  validPass: 'Valid pass',
  failure: 'Failed',
  warning: 'Warning',
  cameraNotAvailable: 'Camera is not available in this browser. Use manual entry.',
  cameraActive: 'Camera active. Place the QR code inside the frame.',
  checking: 'Checking...',
  validateThisCode: 'Validate this code',
  director: 'Director',
  employee: 'Employee',
  forfeoProofRecorded: 'Forfeo proof recorded',
  forfeoProofRecordedText: 'This validation is now recorded in the secure Forfeo log. It links the voucher, order, business and signed-in merchant user.',
  source: 'Source',
  merchantAction: 'Merchant action',
  redeemedNotReusable: 'Redeemed / not reusable',
  legacyOrderCodes: 'Legacy order codes',
  noHistoricalValidation: 'No recent historical validation.',
  validated: 'Validated',
  orderHistory: 'Order history',
  noOrderRecorded: 'No order recorded yet.',
  reference: 'Reference',
  anonymous: 'Anonymous',
  voucherCode: 'Code',
  businessNotFound: 'Business not found.',
  adminPaymentsTitle: 'Payments & vouchers center', adminPaymentsSubtitle: 'Monitor orders, vouchers, merchant validations and webhook anomalies.', centerUnavailable: 'Admin center unavailable', loadingAdminCenter: 'Loading payments center...', latestSync: 'Last sync', paidOrdersStat: 'Paid orders', pendingOrdersStat: 'Pending orders', activeVouchersStat: 'Active vouchers', redeemedVouchersStat: 'Redeemed vouchers', anomalies: 'Anomalies', recentViews: 'Recent views', checkBeforeSupport: 'Check before support', ordersVouchersLoaded: 'Orders + vouchers loaded', searchPlaceholderAdmin: 'Search by email, voucher code, order ID, status, Stripe...', actionCompleted: 'Action completed', actionImpossible: 'Action impossible', anomaliesToCheck: 'Anomalies to check', anomaliesSubtitle: 'Quick detection of inconsistent orders/vouchers with secure recovery actions.', itemsCount: 'item(s)', noAnomaly: 'No anomaly detected in the recent sample.', severity: 'Severity', type: 'Type', message: 'Message', regenerate: 'Regenerate', latestOrders: 'Latest orders', latestOrdersSubtitle: 'Recent Shop/Stripe orders with payment status.', noOrderFound: 'No order found.', fulfillment: 'Fulfillment', receipt: 'Receipt', latestVouchers: 'Latest vouchers', latestVouchersSubtitle: 'Recently generated vouchers with operational status.', noVoucherFound: 'No voucher found.', recentMerchantValidations: 'Latest merchant validations', recentMerchantValidationsSubtitle: 'Voucher redemption log by partners.', noValidationFound: 'No recent validation.', openOrderDetails: 'Order details', resendReceipt: 'Resend receipt', regenerateVouchers: 'Regenerate vouchers', cancelVoucher: 'Cancel voucher',
};

const dictionaries: Record<'fr' | 'en', Dict> = { fr, en };

export const getLanguageCode = (language?: string) => (String(language || 'fr').toLowerCase().startsWith('en') ? 'en' : 'fr');

export const getTransactionLabel = (key: string, language?: string) => {
  const lang = getLanguageCode(language);
  return dictionaries[lang][key] || dictionaries.fr[key] || key;
};

export const getVoucherStatusLabel = (status?: string | null, language?: string) => {
  const normalized = String(status || 'active').toLowerCase();
  return getTransactionLabel(normalized, language);
};

export const getOrderStatusLabel = (status?: string | null, language?: string) => {
  const normalized = String(status || 'pending').toLowerCase();
  return getTransactionLabel(normalized, language) || status || getTransactionLabel('unknown', language);
};

export const getScanSourceLabel = (source?: string | null, language?: string) => {
  if (String(source || '').toLowerCase() === 'camera') return getTransactionLabel('merchantCamera', language);
  return getTransactionLabel('manualEntry', language);
};

export const useTransactionI18n = () => {
  const { i18n } = useTranslation();
  const language = getLanguageCode(i18n.language);
  const tx = (key: string) => getTransactionLabel(key, language);
  return {
    language,
    locale: language === 'en' ? 'en-CA' : 'fr-CA',
    tx,
    voucherStatus: (status?: string | null) => getVoucherStatusLabel(status, language),
    orderStatus: (status?: string | null) => getOrderStatusLabel(status, language),
    scanSource: (source?: string | null) => getScanSourceLabel(source, language),
  };
};
